// Redux
import { useDispatch, useSelector } from "react-redux";
import { setAlert, setLoading } from "../../../../../reducers/userConfigSlice";
// Components
import { FloatPanel } from "../../../../../components/floatPanel";
import { CustomBlock } from "../../../../../components/customBlock";
import { Details } from "./details";
import { ProductOrganization } from "./productOrgatization";
import { Alergens } from "./alergens";
import { Attributes } from "./attributes";
import { Variants } from "./variants";
import { getProduct, updateProductStatus } from "../../../../../api/products";
import { translateMessage } from "@delibrandev/utils";
import { PanelContent } from "../../../../../components/floatPanelContent";

import { ProductEditorPage } from "./productEditorPage";

export const Edition = ({ pageEditor = false }) =>
  pageEditor ? <ProductEditorPage /> : <LegacyEdition />;

const LegacyEdition = () => {
  /******* REQUIRED VARIABLES ********/
  const dispatch = useDispatch();
  const isEmpty = useSelector(
    (state) => state.aplicationConfig.userConfig.floatPanel.isEmpty,
  );
  const productId =
    useSelector(
      (state) => state.aplicationConfig.userConfig.floatPanel.data?.productId,
    ) || null;

  const queryUpdateProductStatus = async (status) => {
    dispatch(setLoading(true));
    const response = await updateProductStatus(productId, status);
    if (response && !response.error) {
      dispatch(setAlert(translateMessage(response?.message || "Bad request")));
      console.log("Operación exitosa", response);
    } else {
      dispatch(setAlert(translateMessage(response?.message || "Bad request")));
      console.log("Error en la operación");
    }
    dispatch(setLoading(false));
  };

  const tabsContent = [
    {
      content: (
        <>
          <div className="row">
            <div className="col-md-12 col-sm-12">
              <CustomBlock name={"Detalles"} content={<Details />} />
            </div>
            <div className="col-md-12 col-sm-12">
              {productId && !isEmpty && (
                <CustomBlock
                  name={"Organización del producto"}
                  content={<ProductOrganization />}
                />
              )}
            </div>
          </div>
        </>
      ),
    },
    {
      content: (
        <div className="">
          <div className="row">
            <div className="col-12">
              <CustomBlock name={"Alérgenos"} content={<Alergens />} />
            </div>
          </div>
        </div>
      ),
    },
    {
      content: (
        <div className="">
          <div className="row">
            <div className="col-md-12">
              <CustomBlock name={"Atributos"} content={<Attributes />} />
            </div>
          </div>
        </div>
      ),
    },
    {
      content: (
        <div className="">
          <div className="row">
            <div className="col-12">
              <CustomBlock
                name={"Variantes basadas en las opciones activas"}
                content={<Variants />}
              />
            </div>
          </div>
        </div>
      ),
    },
  ];
  const horizontalNavigation = [
    { tab: 0, text: "Detalles", icon: null },
    { tab: 1, text: "Alérgenos", icon: null, disabled: isEmpty },
    { tab: 2, text: "Atributos", icon: null, disabled: isEmpty },
    { tab: 3, text: "Variantes", icon: null, disabled: isEmpty },
  ];

  return (
    <FloatPanel
      template={
        <PanelContent
          entityLabel="producto"
          getQuery={getProduct}
          tabsContent={tabsContent}
          handleActive={queryUpdateProductStatus}
          horizontalNavigation={horizontalNavigation}
        />
      }
    />
  );
};
